import { createRoute } from '@/utils/routing'

export const BANNER_LIST_ROUTE = 'banners'
export const BANNER_CREATE_ROUTE = 'banners-create'
export const BANNER_EDIT_ROUTE = 'banners-bannerId-edit'

export function createBannerListRoute (options = {}) {
  return createRoute(BANNER_LIST_ROUTE, options)
}

export function createBannerCreateRoute (options = {}) {
  return createRoute(BANNER_CREATE_ROUTE, options)
}

export function createBannerEditRoute (bannerId, options = {}) {
  if (bannerId != null) {
    return createRoute(BANNER_EDIT_ROUTE, {
      params: { ...options.params, bannerId },
      query: options.query
    })
  }
}
